import FinanceXSubscriptions from './FinanceXSubscriptions.container';

export default FinanceXSubscriptions;
